import React from 'react';

import HistoryGroupDesktopTable from './HistoryGroupDesktopTable';
import HistoryGroupEbaySection from './HistoryGroupEbaySection';
import HistoryGroupHeader from './HistoryGroupHeader';
import HistoryGroupMobileList from './HistoryGroupMobileList';
import { getGroupKey, getGroupImageUrls, normalizeHistoryImageKey } from './historyUtils';

const HistoryGroupCard = ({
  group,
  currentUsername,
  disabledImages,
  rerunningGroup,
  ebaySearchingGroup,
  ebayResultsMap,
  originalItemsById,
  updatingId,
  updatingNameId,
  onOpenImageGroup,
  onOpenItemImage,
  onToggleImage,
  onRerunGroup,
  onSearchEbay,
  onManualNameChange,
  onUpdateItemName,
  onPriceChange,
  onUpdatePrice,
}) => {
  const groupKey = getGroupKey(group);
  const allUrls = getGroupImageUrls(group);
  const groupDisabled = new Set(
    (Array.isArray(disabledImages[groupKey]) ? disabledImages[groupKey] : [])
      .map((key) => normalizeHistoryImageKey(key))
      .filter(Boolean),
  );
  const enabledUrls = allUrls.filter((url) => {
    const key = normalizeHistoryImageKey(url);
    return key && !groupDisabled.has(key);
  });

  return (
    <div className="border border-hairline rounded-lg overflow-hidden shadow-sm">
      <HistoryGroupHeader
        group={group}
        currentUsername={currentUsername}
        disabledImageKeys={disabledImages}
        rerunningGroup={rerunningGroup}
        onOpenImageGroup={onOpenImageGroup}
        onToggleImage={onToggleImage}
        onRerunGroup={onRerunGroup}
      />

      <HistoryGroupDesktopTable
        group={group}
        originalItemsById={originalItemsById}
        updatingId={updatingId}
        updatingNameId={updatingNameId}
        onOpenItemImage={onOpenItemImage}
        onManualNameChange={onManualNameChange}
        onUpdateItemName={onUpdateItemName}
        onPriceChange={onPriceChange}
        onUpdatePrice={onUpdatePrice}
      />

      <HistoryGroupMobileList
        group={group}
        originalItemsById={originalItemsById}
        updatingId={updatingId}
        updatingNameId={updatingNameId}
        onOpenItemImage={onOpenItemImage}
        onManualNameChange={onManualNameChange}
        onUpdateItemName={onUpdateItemName}
        onPriceChange={onPriceChange}
        onUpdatePrice={onUpdatePrice}
      />

      <HistoryGroupEbaySection
        group={{
          ...group,
          blob_urls: enabledUrls.length > 0 ? enabledUrls : allUrls,
        }}
        ebaySearchingGroup={ebaySearchingGroup}
        ebayResultsMap={ebayResultsMap}
        onSearchEbay={onSearchEbay}
      />
    </div>
  );
};

export default HistoryGroupCard;
